import React from "react";

type StatusType = "loading" | "error" | "info" | "success";

export function StatusScreen({
  type,
  message,
  fullScreen = true,
  className = "",
}: {
  type: StatusType;
  message: string;
  fullScreen?: boolean;
  className?: string;
}) {
  const colorClass =
    type === "error"
      ? "text-red-500"
      : type === "loading"
        ? "text-gray-500"
        : type === "success"
          ? "text-green-600"
          : "text-gray-600";

  if (fullScreen) {
    return (
      <main className="flex-1 flex flex-col items-center justify-center">
        <div className={`${colorClass} ${className}`.trim()}>{message}</div>
      </main>
    );
  }

  return (
    <div className={`w-full ${colorClass} ${className}`.trim()}>
      {message}
    </div>
  );
}

export default StatusScreen;
